import React, { useContext, useMemo } from 'react';
const noop = () => {};
const BillingObservableContext = /*#__PURE__*/React.createContext({
  subscribe: noop,
  unsubscribe: noop,
  notifyToRefresh: noop
});
export function useBillingObservable() {
  return useContext(BillingObservableContext);
}
export const BillingObservableProvider = _ref => {
  let {
    children,
    observable
  } = _ref;
  const value = useMemo(() => {
    return {
      subscribe(subscribeData) {
        observable.subscribe(subscribeData);
      },
      unsubscribe(id) {
        observable.unsubscribe(id);
      },
      notifyToRefresh() {
        observable.notify();
      }
    };
  }, [observable]);
  return /*#__PURE__*/React.createElement(BillingObservableContext.Provider, {
    value: value
  }, children);
};